import { render, staticRenderFns } from "./Recibos.vue?vue&type=template&id=76d66138&scoped=true&"
import script from "./Recibos.vue?vue&type=script&lang=js&"
export * from "./Recibos.vue?vue&type=script&lang=js&"
import style0 from "./Recibos.vue?vue&type=style&index=0&id=76d66138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d66138",
  null
  
)

export default component.exports